import { VueRenderer } from '@tiptap/vue-3';
import tippy from 'tippy.js';
import MentionList from './MentionList.vue';
import { userService } from '../../services/userService';

export const suggestion = {
    items: async ({ query }) => {
        try {
            const response = await userService.searchUsers(query);
            return response.users.map(user => ({
                id: user.id,
                label: user.display_name || `${user.first_name} ${user.last_name}`
            }));
        } catch (error) {
            return [];
        }
    },

    render: () => {
        let component = null;
        let popup = null;

        return {
            onStart: props => {
                component = new VueRenderer(MentionList, {
                    props,
                    editor: props.editor,
                });

                if (!popup) {
                    popup = tippy('body', {
                        getReferenceClientRect: props.clientRect,
                        appendTo: () => document.body,
                        content: component.element,
                        showOnCreate: true,
                        interactive: true,
                        trigger: 'manual',
                        placement: 'bottom-start',
                    });
                }
            },

            onUpdate(props) {
                if (component && popup?.[0]) {
                    component.updateProps(props);
                    popup[0].setProps({
                        getReferenceClientRect: props.clientRect,
                    });
                }
            },

            onKeyDown(props) {
                if (props.event.key === 'Escape' && popup?.[0]) {
                    popup[0].hide();
                    return true;
                }
                return component?.ref?.onKeyDown(props);
            },

            onExit() {
                if (popup?.[0] && !popup[0].state.isDestroyed) {
                    popup[0].destroy();
                }
                if (component) {
                    component.destroy();
                }
                popup = null;
                component = null;
            },
        };
    },
};
